/* eslint-disable jsx-a11y/anchor-is-valid */
import '../../../../../../../../App.css'
import {toAbsoluteUrl} from '../../../../../../../../_ePulse/helpers'
import {
  CapsuleImg,
  CertificateImage,
  CertificateImg,
  UserImg,
} from '../../../../../../../../data/config'

export function Template3(props: any) {
  const backgroundStyle = {
    backgroundImage: `url(${props.headerImage})`, // Set the value of the background-image property using the URL of the dynamic image
    backgroundSize: 'cover',
  }
  return (
    // <div className='template-container'>
    //   <div className='template3-header' style={backgroundStyle}>
    //     <div className='header-content'>
    //       {/* <img
    //         className='template-logo'
    //         src={toAbsoluteUrl('/media/ePulse/logoInverse.svg')}
    //         alt=''
    //       /> */}
    //       <h4 className='text-dark ms-3'>Upload Your header</h4>
    //     </div>
    //   </div>
    //   <div className='doctor-details'>
    //     <div className='d-flex align-items-center'>
    //       <UserImg />
    //       <span className='ms-2 label-4'>Dr. Vijay Sankar Sharma</span>
    //     </div>
    //     <div className='d-flex align-items-center'>
    //       <CertificateImg />
    //       <span className='ms-2 label-4'>MBBS</span>
    //     </div>
    //     <div className='d-flex align-items-center'>
    //       <CapsuleImg />
    //       <span className='ms-2 label-4'>Cardiologist</span>
    //     </div>
    //     <div className='d-flex align-items-center'>
    //       <CertificateImage />
    //       <span className='ms-2 label-4'>Registration no- 12341</span>
    //     </div>
    //   </div>
    //   <div className='seperator-line' />
    //   <div className='template-body'>
    //     <div className='patient-details'>
    //       <div className='patient-details-box'>
    //         <div>
    //           <span className='label'>Patient Name: </span> [Patient Name]
    //         </div>
    //         <div>
    //           <span className='label'>Patient Phone No: </span> [0102030405]
    //         </div>
    //         <div>
    //           <span className='label'>Consultatlon Type: </span> Clinic Appointment
    //         </div>
    //       </div>
    //       <div className='patient-details-box'>
    //         <div>
    //           <span className='label'>Consultatlon Date: </span> 26/10/2023
    //         </div>
    //         <div>
    //           <span className='label'>Gender: </span> Male
    //         </div>
    //       </div>
    //     </div>
    //     <div className='seperator-line'></div>
    //     <div className='magin-20'>
    //       <div className='label category'>Vitals</div>
    //       <div className='margin-10'>
    //         <div className='label'>Basic Vitals</div>
    //         <div className='text-font-family'>CVS: 1234</div>
    //         <div className='text-font-family'>Blood Pressure: 120/80 mmHg</div>
    //       </div>
    //       <div className='margin-10'>
    //         <div className='label'>Selective Vitals</div>
    //         <div className='text-font-family'>CVS: 1234</div>
    //         <div className='text-font-family'>Blood Pressure: 120/80 mmHg</div>
    //       </div>
    //     </div>
    //     <div className='magin-20'>
    //       <div className='label category'>Complaints</div>
    //       <div className='text-font-family'>
    //         Itchy palms, cardiomegaly, strawberry cervix, eyeball is swollen, itchy eye, clogged
    //         pores in bald spots, sternal lift
    //       </div>
    //     </div>
    //     <div className='magin-20'>
    //       <div className='label category'>Diagnosis</div>
    //       <div className='text-font-family'>Obesity, Hypertension</div>
    //     </div>
    //     <div className='magin-20'>
    //       <div className='label category'>Rx</div>
    //       <table
    //         className='w-100'
    //         // cellpadding="0" cellspacing="0"
    //       >
    //         <tr className='label'>
    //           <td className='table-head'></td>
    //           <td className='table-head'>Medicine</td>
    //           <td className='table-head'>Dose</td>
    //           <td className='table-head'>Timing</td>
    //           <td className='table-head'>Duration</td>
    //         </tr>
    //         <tr>
    //           <td className='table-data'>1</td>
    //           <td className='table-data'>
    //             <span className='label'>Dolo 50mg</span> <br />
    //             <span className='label-2'>(Paracetamol)</span>
    //           </td>
    //           <td className='table-data'>0-0-1</td>
    //           <td className='table-data'>After meal</td>
    //           <td className='table-data'>5 days</td>
    //         </tr>
    //         <tr>
    //           <td className='table-data'>2</td>
    //           <td className='table-data'>
    //             <span className='label'>Omnacortil 10 MG Tablet</span> <br />
    //             <span className='label-2'>(Prednisolone)</span>
    //           </td>
    //           <td className='table-data'>1-0-1</td>
    //           <td className='table-data'>After meal</td>
    //           <td className='table-data'>7 days</td>
    //         </tr>
    //         <tr>
    //           <td className='table-data'>3</td>
    //           <td className='table-data'>
    //             <span className='label'>Advil 10 MG Drops</span> <br />
    //             <span className='label-2'>(Ibuprofen)</span>
    //           </td>
    //           <td className='table-data'>1-1-1</td>
    //           <td className='table-data'>before meal</td>
    //           <td className='table-data'>10 days</td>
    //         </tr>
    //       </table>
    //     </div>
    //     <div className='magin-20'>
    //       <div className='label category'>Test Required</div>
    //       <div className='text-font-family'>ECG, FBS</div>
    //     </div>
    //     <div className='magin-20'>
    //       <div className='label category'>Advice</div>
    //       <div className='text-font-family'>Drink more water, Exercise Regularly</div>
    //     </div>
    //   </div>
    //   <div className='seperator-line' />
    //   <div className='template-footer'>
    //     <div>
    //       <span className='label-3;'>Dr. Vijay Sankar Sharma</span>
    //       <br />
    //       <span className='label-4'>C-Scheme, Jaipur</span>
    //     </div>
    //     <div>
    //       <span className='text-font-family'>
    //         <img src='/media/ePulse/phone_logo.svg' className='footer-img' alt='' />
    //         +91-1020304050
    //       </span>
    //       <br />
    //       <span className='text-font-family'>
    //         <img src='/media/ePulse/email_logo.svg' className='footer-img' alt='' />
    //         vijay.sharma@getwell.com
    //       </span>
    //       <br />
    //       <span className='text-font-family'>
    //         <img src='/media/ePulse/website_icon.svg' className='footer-img' alt='' />
    //         vijay.sharma@getwell.com
    //       </span>
    //     </div>
    //   </div>
    //   <div className='footer-line-1' />
    //   <div className='footer-line-2' />
    // </div>

    <div className='template-container'>
      <div className='template3-header' style={backgroundStyle}>
        <div className='header-content'>
          {/* <img
            className='template-logo'
            src={toAbsoluteUrl('/media/ePulse/logoInverse.svg')}
            alt=''
          /> */}
          <h4 className='text-dark text-font-family data-font-size'>Upload Your header</h4>
        </div>
      </div>
      <div className='doctor-details'>
        <div className='d-flex align-items-center'>
          <UserImg />
          <span className='ms-2 label-4'>Dr. Vijay Sankar Sharma</span>
        </div>
        <div className='d-flex align-items-center'>
          <CertificateImg />
          <span className='ms-2 label-4'>MBBS</span>
        </div>
        <div className='d-flex align-items-center'>
          <CapsuleImg />
          <span className='ms-2 label-4'>Cardiologist</span>
        </div>
        <div className='d-flex align-items-center'>
          <CertificateImage />
          <span className='ms-2 label-4'>Registration no- 12341</span>
        </div>
      </div>
      <div className='seperator-line' />
      <div className='template-body'>
        <div className='patient-details'>
          <div className='patient-details-box'>
            <div>
              <span className='label'>Patient Name: </span> [Patient Name]
            </div>
            <div>
              <span className='label'>Patient Phone No: </span> [0102030405]
            </div>
            <div>
              <span className='label'>Gender / Age : </span> Male / 25y 2m
            </div>
          </div>
          <div className='patient-details-box'>
            <div>
              <span className='label'>Consultatlon Date: </span> 26/10/2023
            </div>
            <div>
              <span className='label'>Consultatlon Type: </span> Clinic Appointment
            </div>
          </div>
        </div>
        <div className='seperator-line'></div>
        <div className='magin-20'>
          <div className='category'>Vitals</div>
          <div className='margin-10'>
            <div className='sub-category'>Basic Vitals</div>
            <div className='text-font-family data-font-size'>CVS: 1234</div>
            <div className='text-font-family data-font-size'>Blood Pressure: 120/80 mmHg</div>
          </div>
          <div className='margin-10'>
            <div className='sub-category'>Selective Vitals</div>
            <div className='text-font-family data-font-size'>CVS: 1234</div>
            <div className='text-font-family data-font-size'>Blood Pressure: 120/80 mmHg</div>
          </div>
        </div>
        <div className='magin-20'>
          <div className='category'>Complaints</div>
          <div className='text-font-family data-font-size'>
            Itchy palms, cardiomegaly, strawberry cervix, eyeball is swollen, itchy eye, clogged
            pores in bald spots, sternal lift
          </div>
        </div>
        <div className='magin-20'>
          <div className='category'>Diagnosis</div>
          <div className='text-font-family data-font-size'>Obesity, Hypertension</div>
        </div>
        <div className='magin-20'>
          <div className='category'>Rx</div>
          <table
            className='w-100'
            // cellpadding="0" cellspacing="0"
          >
            <tr className='label'>
              <td className='table-head'></td>
              <td className='table-head'>Medicine</td>
              <td className='table-head'>Dose</td>
              <td className='table-head'>Timing</td>
              <td className='table-head'>Duration</td>
            </tr>
            <tr>
              <td className='table-data'>
                <span className='label'>Dolo 50mg</span> <br />
                <span className='label-2'>(Paracetamol)</span>
              </td>
              <td className='table-data'>0-0-1</td>
              <td className='table-data'>After meal</td>
              <td className='table-data'>5 days</td>
            </tr>
            <tr>
              <td className='table-data'>
                <span className='label'>Omnacortil 10 MG Tablet</span> <br />
                <span className='label-2'>(Prednisolone)</span>
              </td>
              <td className='table-data'>1-0-1</td>
              <td className='table-data'>After meal</td>
              <td className='table-data'>7 days</td>
            </tr>
            <tr>
              <td className='table-data'>
                <span className='label'>Advil 10 MG Drops</span> <br />
                <span className='label-2'>(Ibuprofen)</span>
              </td>
              <td className='table-data'>1-1-1</td>
              <td className='table-data'>before meal</td>
              <td className='table-data'>10 days</td>
            </tr>
          </table>
        </div>
        <div className='magin-20'>
          <div className='category'>Test Required</div>
          <div className='text-font-family data-font-size'>ECG, FBS</div>
        </div>
        <div className='magin-20'>
          <div className='category'>Advice</div>
          <div className='text-font-family data-font-size'>
            Drink more water, Exercise Regularly
          </div>
        </div>
      </div>
      <div className='seperator-line' />
      <div className='template-footer'>
        <img className='template-logo' src={toAbsoluteUrl('/media/ePulse/logo3.png')} alt='' />
        <div>
          <span className='data-font-size text-font-family'>Dr. Vijay Sankar Sharma</span>
          <br />
          <span className='data-font-size text-font-family'>C-Scheme, Jaipur</span>
        </div>
        <div>
          <span className='text-font-family data-font-size'>
            <img src='/media/ePulse/phone_logo.svg' className='footer-img' alt='' />
            +91-1020304050
          </span>
          <br />
          <span className='text-font-family data-font-size'>
            <img src='/media/ePulse/email_logo.svg' className='footer-img' alt='' />
            vijay.sharma@getwell.com
          </span>
          <br />
          <span className='text-font-family data-font-size'>
            <img src='/media/ePulse/website_icon.svg' className='footer-img' alt='' />
            vijay.sharma@getwell.com
          </span>
        </div>
      </div>
      <div className='footer-line-1' />
      <div className='footer-line-2' />
    </div>
  )
}
